module.exports = __webpack_public_path__ + "static/assets/04235ccfc707d61ed3949fd7445e5e40.svg";